import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import { Popover, Typography } from '@mui/material';
import clsx from 'clsx';
import Tooltip from 'components/Tooltip';
import PropTypes from 'prop-types';

import styles from '../sidebar.module.css';

function RailFlyout({ item, isActive, children }) {
    const [anchorEl, setAnchorEl] = useState(null);
    const location = useLocation();
    const isOpen = Boolean(anchorEl);
    const flyoutId = `${item.id}-flyout`;

    // Picking a link changes the location, which closes the flyout.
    useEffect(() => {
        setAnchorEl(null);
    }, [location]);

    return (
        <>
            <Tooltip
                title={isOpen ? '' : item.label}
                placement="right"
                classes={{ tooltip: styles.collapseTooltip }}
            >
                <button
                    type="button"
                    data-tour={item.id}
                    className={clsx(
                        styles.navItem,
                        styles.navItemButton,
                        styles.navItemCollapsed,
                        (isActive || isOpen) && styles.navItemActive
                    )}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                    aria-label={item.label}
                    aria-haspopup="dialog"
                    aria-expanded={isOpen}
                    aria-controls={isOpen ? flyoutId : undefined}
                >
                    <span className={styles.navIcon}>{item.icon}</span>
                </button>
            </Tooltip>
            <Popover
                id={flyoutId}
                open={isOpen}
                anchorEl={anchorEl}
                onClose={() => setAnchorEl(null)}
                anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                classes={{ paper: styles.flyoutPaper }}
            >
                <Typography component="h2" className={styles.flyoutTitle}>
                    {item.label}
                </Typography>
                {children}
            </Popover>
        </>
    );
}

RailFlyout.propTypes = {
    item: PropTypes.object.isRequired,
    isActive: PropTypes.bool,
    children: PropTypes.node,
};

export default RailFlyout;
